module.exports = __webpack_public_path__ + "media/images/payment-providers/mastercard-card-2f5fb54efbc79e3f649c3623397eb853.svg";